import React from 'react';

interface ContainerIconProps {
  className?: string;
}

const ContainerIcon: React.FC<ContainerIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="m24,5v-2H0v2h1v14H0v2h24v-2h-1V5h1Zm-3,14H3V5h18v14Zm-3-2h-2V7h2v10Zm-5,0h-2V7h2v10Zm-7,0V7h2v10h-2Z"/>
    </svg>
  );
};

export default ContainerIcon;
